import axios from "axios";
import {
  AccountDelinkInitiateRequest,
  AccountDelinkVerificationRequest,
} from "../../Models/Request/Account/AccountDelink";
import { AccountLinkInitiateRequest } from "../../Models/Request/Account/AccountLink";
import { DiscoverAccountRequest } from "../../Models/Request/Account/DiscoverAccount";

export function getLinkedAccountsOfUser() {
  return axios.get(`/User/linkedaccount`);
}

export function getDeLinkedAccountsOfUser() {
  return axios.get(`/User/delinkedaccount`);
}

export function discoverAccounts(
  discoverAccountRequest: DiscoverAccountRequest
) {
  return axios.post("/User/account/discovery", discoverAccountRequest);
}

export function linkAccounts(accountLinkBody: AccountLinkInitiateRequest) {
  return axios.post("/User/account/link", accountLinkBody);
}

export function linkAccountVerification(
  RefNumber: string,
  otp: string,
  handleId: string
) {
  return axios.get(`/User/account/link/${RefNumber}/${otp}?FipId=${handleId}`);
}

export function getConsentLinkedWithAccount(
  FipId: String,
  linkRefNumber: String
) {
  return axios.get(
    `User/account/getAllConsentsCount?FipId=${FipId}&linkRefNumber=${linkRefNumber}`
  );
}

export function delinkAccounts(
  accountdeLinkBody: AccountDelinkInitiateRequest
) {
  return axios.post("/User/account/delink", accountdeLinkBody);
}

export function delinkAccountVerification(
  delinkAccountVerificationBody: AccountDelinkVerificationRequest
) {
  return axios.delete("/User/account/delink/Verification", {
    data: delinkAccountVerificationBody,
  });
}
